import { apiSlice } from './apiSlice';

// Use environment variable for Strava API base URL, fallback to proxy path for development  
const STRAVA_URL = import.meta.env.VITE_API_BASE_URL 
  ? `${import.meta.env.VITE_API_BASE_URL}/strava`
  : '/strava';

export const stravaApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStravaAuthUrl: builder.mutation({
      query: () => ({
        url: `${STRAVA_URL}/auth/url`,
        method: 'GET',
        credentials: 'include',
      }),
    }),
    getStravaActivities: builder.query({
      query: () => ({
        url: `${STRAVA_URL}/activities`,  // Backend endpoint to fetch activities
        method: 'GET',  // Fetching data, so use GET method
        credentials: 'include',  // Ensure cookies are included in the request
      }),
    }),
    fetchStravaToken: builder.mutation({
      query: (code) => ({
        url: `${STRAVA_URL}/auth/strava/callback`,  // Callback to exchange code for token
        method: 'POST',
        body: { code },  // Sending the code received from Strava
        credentials: 'include',
      }),
    }),
    importStravaActivities: builder.mutation({
      query: () => ({
        url: `${STRAVA_URL}/import-activities`,
        method: 'POST',
        credentials: 'include',
      }),
      invalidatesTags: ['Event', 'Athlete', 'Team'], // Invalidate related data
    }),
    getImportStatus: builder.query({
      query: () => ({
        url: `${STRAVA_URL}/import-status`,
        method: 'GET',
        credentials: 'include',
      }),
      providesTags: ['StravaImport'],
    }),
    disconnectStrava: builder.mutation({
      query: () => ({
        url: `${STRAVA_URL}/disconnect`,
        method: 'POST',
        credentials: 'include',
      }),
      invalidatesTags: ['User', 'StravaImport'],
    }),
  }),
});

// Export the hooks for the Strava API slice
export const {
  useGetStravaAuthUrlMutation,
  useGetStravaActivitiesQuery,
  useFetchStravaTokenMutation,
  useImportStravaActivitiesMutation,
  useGetImportStatusQuery,
  useDisconnectStravaMutation,
} = stravaApiSlice;